// import RecruitInvitTokenModel from 'models/recruit/InviteTokenModel'
import Logger from 'utils/logging'
import { clientWithNoHeaders } from './client'

export async function createRecruitmentCode(
    userToken: string
): Promise<boolean> {
    // Have to send empty body so that Axios will not remove
    // Content-Type: aplication/json from the header.
    // console.log('createRecruitmentCode called')
    // return true
    const tokenCreated = await clientWithNoHeaders({
        url: '/invite/token',
        method: 'post',
        data: {},
        headers: {
            Authorization: `Bearer ${userToken}`,
            ContentType: 'application/json',
        },
    })
        .then((result) => {
            // console.log('Recruitment Rewards api call list', result.status)
            return result.status === 201
        })
        .catch((error) => {
            Logger.captureNetworkException(
                error,
                '/invite/token/post',
                'recruit.token'
            )
            return false
        })

    return tokenCreated
}

/*
 * Get a users recruitment code
 * @returns the users recruitment code
 */
export default async function getRecruitmentCode(
    userToken: string
): Promise<string> {
    const token = await clientWithNoHeaders({
        url: '/invite/token',
        method: 'get',
        headers: {
            Authorization: `Bearer ${userToken}`,
            Pragma: 'no-cache',
        },
    })
        .then((result) => {
            // console.log('Recruitment code api call', result)
            return result && result.data.token
        })
        .catch((response) => {
            if (!response) {
                Logger.captureNetworkException(
                    response,
                    'invite/token',
                    'recruit.inviteToken'
                )
            } else if (response.status === 404) {
                console.log('No token found, creating one')
                return ''
            }
            return ''
        })

    return token
}
